import { Typography } from '@ori-ui/mui';
import { type FC } from 'react';

export interface CountryInfoProps {
  label: string;
  value: string;
}
export const CountryInfo: FC<CountryInfoProps> = ({ label, value }) => {
  if (!label || !value) {
    return null;
  }

  return (
    <Typography>
      {label}: {value}
    </Typography>
  );
};
